// @flow

import type { PendingIncomingPayment } from './types';

export function getSafePixCopiaECola(incomingPayment: PendingIncomingPayment): string {
  const copiaECola = incomingPayment['pix']['copia_e_cola'];
  if(!copiaECola){
    throw new Error('Pix: no copia_e_cola in incoming payment');
  }
  return copiaECola;
}
